export const DEFAULT_CYCLE_SCRIPT = `function execute(context, services) {
  var needCert = (context && context.needCert) || '';
  var moldType = (context && context.moldType) || '';
  var grade = (context && context.grade) || '';

  if (needCert === '是') {
    return { months: 19, label: '特证项目' };
  } else if (moldType === '公模') {
    return { months: 10, label: '公模' };
  } else if (moldType === '开模') {
    if (grade === 'S') {
      return { months: 11.5, label: 'S级私模' };
    }
    return { months: 11, label: '私模默认' };
  } else if (moldType === '待定') {
    return { months: 11.5, label: '待定按S私模' };
  }
  return { months: 0, label: '无匹配，不推算' };
}
`;

export type CycleConfig = {
  version: number;
  script: string;
};

export const DEFAULT_CYCLE: CycleConfig = {
  version: 5,
  script: DEFAULT_CYCLE_SCRIPT,
};

export function normalizeCycleConfig(raw: any): CycleConfig {
  if (raw && typeof raw.script === 'string' && raw.script.trim()) {
    return { version: 5, script: raw.script };
  }
  if (typeof raw === 'string' && raw.includes('function execute')) {
    return { version: 5, script: raw };
  }
  return { version: 5, script: DEFAULT_CYCLE_SCRIPT };
}
